import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

interface Props {
  readOnly?: boolean;
  editMode?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      //'& h3': { margin: theme.spacing(2, 0) },
      '& .MuiListItemText-secondary': { fontSize: '0.8rem', margin: 0 },
      [theme.breakpoints.down('xs')]: {
        '& .MuiTypography-body1': { fontSize: '13px !important' },
        '& .MuiListItem-gutters': { padding: 0 },
      },
      '& .MuiListItem-root': {
        minHeight: '48px',
      },
    },
    list: {
      background: theme.palette.background.paper,
      '& .MuiListItem-gutters': {
        padding: 0,
        minHeight: theme.spacing(6),
        [theme.breakpoints.down('xs')]: {
          flexWrap: 'wrap',
        },
      },
    },
    label: (props: Props) => ({
      //width: props.readOnly ? '80%' : '54%',
      width: '67%',
      display: 'inline-block',
      flexGrow: 0,
      [theme.breakpoints.down('xs')]: {
        width: props.readOnly ? undefined : '44%',
      },
    }),
    performanceLabel: (props: Props) => ({
      width: props.editMode ? '67%' : '69%',
      display: 'inline-block',
      flexGrow: 0,
      [theme.breakpoints.down('xs')]: {
        width: props.editMode || !props.readOnly ? '44%' : '73%',
      }

    }),
    label2: {
      width: '80%',
    },
    halfLabel: (props: Props) => ({
      //width: props.readOnly ? '50%' : '34%',
      width: '47%',
      display: 'inline-block',
      flexGrow: 0,
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    }),
    secondary: (props: Props) => ({
      width: '20%',
      //EDS-4915 width: props.readOnly ? '30%' : '20%',
      display: 'inline-block',
      flexGrow: 0,
      [theme.breakpoints.down('xs')]: {
        //EDS-4915 width: props.readOnly ? '80%' : '44%',
        width: '44%',
      },
    }),
    values: (props: Props) => ({
      display: 'inline-block',
      //width: props.readOnly ? '20%' : '14%',
      width: '25%',
      flexShrink: 1,
      flexGrow: 0,
      textAlign: 'right',
    }),
    sum: {
      '& .MuiListItemText-secondary': {
      fontWeight: 800,
      fontSize: '14px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '13px',
      }
      },
      '& .MuiTypography-body1': {
        fontWeight: 800,
        fontSize: '14px',
        paddingRight: '50px',
        [theme.breakpoints.down('xs')]: {
          paddingRight: '20px'
        }
      },
    },
    input: {
      display: 'inline-flex',
      flex: '0 0 auto',
      width: '14%',
      [theme.breakpoints.down('xs')]: {
        width: '29%',
      },
      '@media (max-width: 400px)': {
        width: '26%',
        '& .MuiSelect-outlined.MuiSelect-outlined': {
          paddingLeft: '4px',
          paddingRight: '7px',
          fontSize: '90%',
        },
        '& .MuiSelect-iconOutlined': {
          right: '2px',
        },
      },
    },
    info: {
      width: '22%',
      textAlign: 'center',
      flexGrow: 0,
      [theme.breakpoints.down('xs')]: {
        width: '10%',
      },
    },
    plus: {
      width: '1%',
      textAlign: 'center',
      [theme.breakpoints.down('xs')]: {
        width: '0.5%',
      },
    },
    disabled: {
      color: theme.palette.text.disabled,
      textAlign: 'left',
    },
    singleFees: {
      background: theme.palette.background.paper,
      '& input': {
        textAlign: 'right',
      },
    },
    section: {
      background: theme.palette.grey[50],
    },
    sectionTitle: {
      background: theme.palette.grey[50],
      margin: 0,
      padding: theme.spacing(2, 0),
    },
    sub: {
      paddingLeft: theme.spacing(4),
    },
    em: {
      fontWeight: 'bold',
      '& span.MuiTypography-root': { fontSize: '18px', fontWeight: 800 },
    },
    bold: { '& span.MuiTypography-root': { fontWeight: 700 } },
    maxWidth: {
      maxWidth: '100%',
    },
    box: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexGrow: 1,
    },
    itemBetween: {
      minHeight: 48,
      display: 'flex',
      justifyContent: 'space-between',
      '& > .MuiBox-root': {
        width: '95%',
        '@media (max-width: 500px)': {
          width: '92%',
          flexGrow: 0,
        },
      },
      '& > span': {
        width: '5%',
        textAlign: 'center',
        '@media (max-width: 500px)': {
          width: '6%',
        },
      },
      '& .MuiFormControl-fullWidth': {
        width: '150px',
      },
    },
    fee: {
      flexGrow: 0,
    },
    singleLabel: {
      width: '80%',
    },
    singleFee: {
      flexGrow: 0,
      textAlign: 'right',
      width: '20%',
      '@media (max-width: 500px)': {
        width: '45%',
      },
    },
    singleFeeLong: { width: '40%' },
    nested: {
      paddingLeft: theme.spacing(4),
      [theme.breakpoints.down('xs')]: {
        paddingLeft: 0,
      },
    },

    doubleNested: {
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(20),
    },
    buttons: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(1, 0),
      '& > *, & svg': {
        margin: theme.spacing(0, 1, 0, 0),
      },
    },
    title: {
      paddingLeft: theme.spacing(2),
      position: 'relative',
      '& > span': {
        fontSize: '14px',
      },
    },
    controlButtons: {
      marginTop: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& > div > div': {
        marginTop: 0,
      },
    },
  }),
);

export default useStyles;
